export const RUNTIME_NAME = '/public/v1/get-ad-banner-microfrontend/';
